import { Cart } from './Cart.js';
import { ProductForm } from './ProductForm.js';
import { BandsintownWidget } from './BandsintownWidget.js';
import { CartItem } from './CartItem.js';
import { CartCount } from './CartCount.js';
import { GridControl } from './GridControl.js';
import { ArtistProfileForm } from './ArtistProfileForm.js';

const cart = new Cart();

customElements.define('product-form', ProductForm);
customElements.define('bandsintown-widget', BandsintownWidget);
customElements.define('cart-item', CartItem);
customElements.define('cart-count', CartCount);
customElements.define('grid-control', GridControl);
customElements.define('artist-profile-form', ArtistProfileForm);

// Additional refs

document.addEventListener('click', (e) => {
	if (e.target.closest('[data-ref="cartToggle"]')) {
		cart.sideCartToggle.checked = true;
	}
});
